// =============================================================
//  MayaFloatingButton — Bouton flottant pour ouvrir le chat Maya
//  Se place sur l'accueil, empilé au-dessus du bouton WhatsApp.
//  Icône seule (sans texte), animée : entrée fade/scale + halo pulsant.
//  Synchronisé entre la version mobile et la version web.
// =============================================================

import React, { useEffect, useRef } from 'react';
import { StyleSheet, TouchableOpacity, Animated } from 'react-native';
import MayaIcon from './MayaIcon';

export default function MayaFloatingButton({ onPress, bottom = 212 }) {
  // Animation d'apparition (scale + opacité)
  const appear = useRef(new Animated.Value(0)).current;
  // Animation de pression
  const press = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.spring(appear, {
      toValue: 1,
      friction: 5,
      tension: 60,
      delay: 600,
      useNativeDriver: true,
    }).start();
  }, [appear]);

  const handlePressIn = () => {
    Animated.spring(press, {
      toValue: 1,
      useNativeDriver: true,
    }).start();
  };

  const handlePressOut = () => {
    Animated.spring(press, {
      toValue: 0,
      friction: 4,
      useNativeDriver: true,
    }).start();
  };

  const appearScale = appear.interpolate({
    inputRange: [0, 1],
    outputRange: [0.4, 1],
  });
  const pressScale = press.interpolate({
    inputRange: [0, 1],
    outputRange: [1, 0.9],
  });

  return (
    <Animated.View
      style={[
        styles.container,
        {
          bottom,
          opacity: appear,
          transform: [{ scale: Animated.multiply(appearScale, pressScale) }],
        },
      ]}
    >
      <TouchableOpacity
        activeOpacity={0.85}
        onPress={onPress}
        onPressIn={handlePressIn}
        onPressOut={handlePressOut}
      >
        <MayaIcon size={56} animated />
      </TouchableOpacity>
    </Animated.View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    right: 20,
    zIndex: 999,
    alignItems: 'center',
  },
});
